export default "__VITE_ASSET__0ea0afd8__"